import React from 'react';
import Header from '@/components/shared/Header';
import Footer from '@/components/shared/Footer';
import Chatbot from '@/components/shared/Chatbot';

const JobDetails = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="max-w-7xl mx-auto px-4 py-20">
        <h1 className="text-4xl font-bold mb-6">JobDetails</h1>
        <p>Job portal content coming soon.</p>
      </div>
      <Footer />
      <Chatbot />
    </div>
  );
};

export default JobDetails;
